<template>
	<div v-cloak>
		<transition name="fade">
			<div class="cookies" v-if="!acceptedCookies">
				<div class="cookies__wrap">
					<div class="cookie-item">

						<p>Vi anvender cookies til at huske dine indstillinger, statistik og målrette annoncer.</p>

					</div>

					<div class="cookie-item flex__end">

						<a class="btn--primary" href="#" @click.prevent="acceptCookies" dusk="accept">OK</a>

						<a class="btn--secondary" href="https://naesbyhovedskov.dk/cookie-og-privatlivspolitik">Læs mere</a>

					</div>

				</div>
			</div>
		</transition>
	</div>
</template>

<script>
    import Cookies from 'js-cookie';

    export default {
        name: "cookie",
        data() {
            return {
                acceptedCookies: false,
            }
        },
        methods: {
            acceptCookies() {
                Cookies.set('has-accepted-nhs-cookies', true, {
                    domain: 'naesbyhovedskov.dk',
				});
                this.acceptedCookies = true;
            }
        },
        created() {
            if (Cookies.get('has-accepted-nhs-cookies') === 'true') {
                this.acceptedCookies = true;
            }
        }
    }
</script>
